import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const AddedToCollection = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M4.8,6.6 L3,6.6 L3,19.2 C3,20.19 3.81,21 4.8,21 L17.4,21 L17.4,19.2 L5.8,19.2 C5.24771525,19.2 4.8,18.7522847 4.8,18.2 L4.8,6.6 L4.8,6.6 Z M19.2,3 L8.4,3 C7.41,3 6.6,3.81 6.6,4.8 L6.6,15.6 C6.6,16.59 7.41,17.4 8.4,17.4 L19.2,17.4 C20.19,17.4 21,16.59 21,15.6 L21,4.8 C21,3.81 20.19,3 19.2,3 Z M11.8888889,14.1044444 L8,10.2155556 L9.09666667,9.11888889 L11.8888889,11.9033333 L17.7922222,6 L18.8888889,7.10444444 L11.8888889,14.1044444 Z" })));
};
export default AddedToCollection;
